// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopSimpleOutlinedSvg from "@fishx/icons-svg/es/asn/ShopSimpleOutlined";
import FishxIcon from '../components/FishxIcon';

var ShopSimpleOutlined = function ShopSimpleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopSimpleOutlinedSvg
  }));
};

ShopSimpleOutlined.displayName = 'ShopSimpleOutlined';
export default React.forwardRef(ShopSimpleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShopSimpleOutlined.js
// module id = 4106
// module chunks = 0